import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import {
  writeAccessToken,
  writeRefreshToken,
} from "src/common/functions/authFunctions";
import { userState } from "src/common/states/loginUser";
import { PageContainer } from "src/components/organisms/contents";

export const SocialCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const setUser = useSetRecoilState(userState);

  useEffect(() => {
    const handleSocialCallback = async () => {
      try {
        // URL 파라미터에서 토큰 직접 읽기
        const token = searchParams.get("token");
        const refreshToken = searchParams.get("refreshToken");
        const user = searchParams.get("user");
        const error = searchParams.get("error");

        if (error) {
          setError("소셜 로그인이 취소되었습니다.");
          setLoading(false);
          return;
        }

        if (!token) {
          setError("토큰을 받을 수 없습니다.");
          setLoading(false);
          return;
        }

        // 토큰 저장
        writeAccessToken(token);
        if (refreshToken) {
          writeRefreshToken(refreshToken);
        }

        // 사용자 정보 저장 (필요한 경우)
        if (user) {
          try {
            const userInfo = JSON.parse(decodeURIComponent(user));
            userInfo && setUser(userInfo);
            // console.log("사용자 정보:", userInfo);
            // 사용자 정보를 추가로 저장하는 로직이 필요한 경우 여기에 추가
          } catch (userError) {
            console.warn("사용자 정보 파싱 오류:", userError);
          }
        }

        // 홈으로 이동
        navigate("/");
      } catch (error) {
        console.error("소셜 로그인 콜백 처리 오류:", error);
        setError(
          error instanceof Error
            ? error.message
            : "로그인 처리 중 오류가 발생했습니다."
        );
      } finally {
        setLoading(false);
      }
    };

    handleSocialCallback();
  }, [searchParams, navigate, setUser]);

  if (loading) {
    return (
      <PageContainer isNavBar={false} active={null}>
        <>
          <div>로그인 처리 중...</div>
          <div
            style={{
              width: "20px",
              height: "20px",
              border: "2px solid #f3f3f3",
              borderTop: "2px solid #FEE500",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            }}
          ></div>
          <style>
            {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
          </style>
        </>
      </PageContainer>
    );
  }

  if (error) {
    return (
      <PageContainer isNavBar={false} active={null}>
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              gap: "12px",
            }}
          >
            <div style={{ color: "#e53e3e", fontSize: "16px" }}>{error}</div>
            <button
              onClick={() => navigate("/auth/login")}
              style={{
                padding: "8px 16px",
                backgroundColor: "#FEE500",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              로그인 페이지로 돌아가기
            </button>
          </div>
        </>
      </PageContainer>
    );
  }

  return null;
};
